"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
function ProductGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {[...Array(12)].map((_, i) => <div key={i} data-index={i} className="aspect-[4/3] w-full animate-pulse bg-muted" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-destructive">
        <p>Gagal memuat video. Silakan coba lagi nanti.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Tidak ada video yang ditemukan.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {posts.map((post, i) => {
      const imageUrl = post.featuredImage || post.customFields?.product_images || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/video_thumbnail_placeholder.png";
      return <div key={post.id} data-index={i} className="group relative block aspect-[4/3] w-full overflow-hidden bg-muted rounded-lg shadow-sm transition-all duration-300 hover:shadow-md hover:scale-[1.02]">
            {}
            <img src={imageUrl} alt={post.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />

            {}
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/30 p-6 text-center transition-colors duration-300 group-hover:bg-black/50">
              {}
              <div className="mb-4 opacity-80 transition-opacity duration-300 group-hover:opacity-100">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-play-circle">
                  <circle cx="12" cy="12" r="10" /><polygon points="10 8 16 12 10 16 10 8" />
                </svg>
              </div>

              <h3 className="font-default absolute bottom-4 left-4 right-4 text-left text-sm font-bold text-white drop-shadow-md">
                {post.title}
              </h3>

              {}
              <div className="absolute right-2 top-2 rounded-md bg-black/70 px-2 py-1 text-[10px] font-semibold text-white">
                {post.customFields?.duration || "LIVE"}
              </div>

              {}
              <Button asChild variant="outline" className="relative z-10 h-auto rounded-md border-white bg-transparent px-6 py-1.5 text-xs uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-black hidden">
                <Link to={post.link || "/live/"}>Putar</Link>
              </Button>
            </div>

            {}
            <Link to={post.link || "/live/"} className="absolute inset-0 z-0" aria-label={`Tonton video ${post.title}`}>
              <span className="sr-only">Tonton {post.title}</span>
            </Link>
          </div>;
    })}
    </div>;
}
export default function VideoLiveDriver() {
  const wp_query_params = {
    post_type: "product",
    per_page: 16
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="252129" id="video-live-driver" className="section bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-12 text-center">
          <h2 className="font-default mb-4 text-3xl font-bold text-foreground md:text-4xl">
            Video & Live Driver
          </h2>
          <div className="mx-auto h-[2px] w-16 bg-primary"></div>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "product",
        per_page: 16
      }}>
          <ProductGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}